export const PEER_CONNECTIVITY_EVENT = 'peer_connectivity_event'

export const PeerConnectivityActions = {
  CANVAS_PAGE_NEXT: 'canvas.navigate.next',
  CANVAS_PAGE_PREVIOUS: 'canvas.navigate.previous',
  CANVAS_OPEN: 'canvas.open',
  CANVAS_CLOSE: 'canvas.close',
  ROUTE_CHANGE: 'route.change',
  FILE_OPEN: 'file.open',
  FILE_CLOSE: 'file.close',
  BROWSER_FOLDER_OPEN: 'browser.folder.open',
} as const

export const DEFAULT_PEER_CONNECTIVITY_VERSION = 1
export const PEER_CONNECTIVITY_HANDLER_MATCH_ALL = '*'
